// registerUser sends the registration payload to the Netlify function.
// If you use SUBMIT_SECRET on the function, include it here so the function can validate.
// NOTE: REACT_APP_SUBMIT_SECRET will be baked into the build and is visible in client code.
// Only use for light protection; for stronger protection use CAPTCHA or server-only secret injection.

export async function registerUser(registrationData) {
  try {
    const secret = process.env.REACT_APP_SUBMIT_SECRET || '';

    // Defensive: normalize/convert age when possible so sheet writer receives a numeric or numeric-string value
    const payload = { ...registrationData, ...(secret ? { secret } : {}) };
    if (payload.age !== undefined && payload.age !== null) {
      if (typeof payload.age === "string") {
        const maybeNum = Number(payload.age);
        if (!Number.isNaN(maybeNum)) {
          payload.age = maybeNum;
        } else if (payload.age.trim() === "") {
          // empty string -> remove so writers don't receive a blank string
          delete payload.age;
        }

      } else if (typeof payload.age === "number") {
        // keep as-is
      } else {
        // other types -> stringify defensively
        payload.age = String(payload.age);
      }
    }

    // Log the payload in the browser console for debugging (remove in production if desired)
    console.log("registerUser payload (about to send):", payload);

    // Primary endpoint: Netlify function. Fallback to backend /api/register if netlify endpoint fails.
    const endpoints = [
      "/.netlify/functions/append-sheet",
      "/api/register"
    ];

    let lastError = null;

    for (const endpoint of endpoints) {
      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        const text = await res.text();
        let data = null;
        try {
          data = text ? JSON.parse(text) : {};
        } catch (e) {
          // not JSON — return raw text in data.payloadText
          data = { payloadText: text };
        }

        if (!res.ok) {
          // log and try next endpoint
          lastError = new Error(`Request to ${endpoint} failed: ${res.status} ${res.statusText}`);
          console.warn(lastError, data);
          continue;
        }

        // success
        return data;
      } catch (err) {
        lastError = err;
        console.warn(`registerUser attempt to ${endpoint} threw:`, err);
        // try next endpoint
      }
    }

    // All endpoints failed
    return { error: lastError ? String(lastError.message || lastError) : "Network error" };
  } catch (error) {
    console.error("registerUser fatal error:", error);
    return { error: "Network error" };
  }
}

export async function registerVbs(vbsData) {
  const res = await fetch("/.netlify/functions/vbs-submit", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(vbsData || {})
  });

  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { error: text || "VBS submission failed." };
  }

  if (!res.ok) {
    throw new Error(data.error || "VBS submission failed.");
  }

  return data;
}

export async function submitSurvey(surveyData) {
  const res = await fetch("/.netlify/functions/survey-submit", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(surveyData),
  });

  const text = await res.text();
  let data = {};

  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = {};
  }

  if (!res.ok) {
    throw new Error(data.error || "Survey submission failed.");
  }

  return data;
}

export default registerUser;
